// Decisão de um pedido de aprovação na tela: o corpo do POST /api/permissions/:id/decision.
// Puro (sem DOM): o cartão e o modal (main.ts) leem o botão e a caixa "interromper" e chamam isto.
//
// "Aprovar e não perguntar de novo" manda a posição da sugestão (`suggestion`); "interromper o
// agente" vai junto de uma recusa (`interrupt`). O servidor confere os dois (src/index.ts).

export interface OpcoesDecisao {
  /** Posição da sugestão de regra escolhida (só vale para aprovar). */
  sugestao?: number;
  /** Interromper o agente ao recusar (só vale para recusar). */
  interromper?: boolean;
}

export interface CorpoDecisao {
  decision: 'allow' | 'deny';
  suggestion?: number;
  interrupt?: true;
}

/** O corpo da decisão. Opções que não cabem na decisão são deixadas de fora (o servidor recusaria). */
export function corpoDaDecisao(decisao: 'allow' | 'deny', opcoes: OpcoesDecisao = {}): CorpoDecisao {
  return {
    decision: decisao,
    ...(decisao === 'allow' && opcoes.sugestao !== undefined ? { suggestion: opcoes.sugestao } : {}),
    ...(decisao === 'deny' && opcoes.interromper ? { interrupt: true as const } : {}),
  };
}

/** A posição da sugestão lida do atributo do botão. Vazio ou que não é inteiro não tem sugestão. */
export function sugestaoDoBotao(valor: string | undefined): number | undefined {
  if (!valor) return undefined;
  const n = Number(valor);
  return Number.isInteger(n) && n >= 0 ? n : undefined;
}
